import React from "react";
import NewsCard from "../../components/NewsCard";
import ThreadCards from "../ThreadCards";
import MoodChart, {BelowThresholdMessage, moodWindowLabel} from "../MoodChart";
import CountUp from "../CountUp";

// Blocs « vivants » : ils lisent les données déjà chargées par la landing (ctx : actualités, fils, humeur des agents,
// effectif) et ne stockent que leurs options d'affichage. Données absentes, vides ou en erreur : le bloc ne s'affiche pas.

const intOption = (value, fallback) => (Number.isInteger(Number(value)) && Number(value) > 0 ? Number(value) : fallback);

function BlockTitle({title}) {
    return title ? <h2 className="serif block-heading">{title}</h2> : null;
}

export function NewsBlock({data, ctx}) {
    const items = (Array.isArray(ctx.news) ? ctx.news : []).slice(0, intOption(data.limit, 3));
    if (items.length === 0) return null;
    return (
        <div className="block-news">
            <BlockTitle title={data.title}/>
            <div className="block-news__grid">
                {items.map(article => <NewsCard key={article.slug} article={article}/>)}
            </div>
        </div>
    );
}

export function ThreadsBlock({data, ctx}) {
    const threads = (Array.isArray(ctx.threads) ? ctx.threads : []).slice(0, intOption(data.limit, 3));
    if (threads.length === 0) return null;
    return (
        <div className="block-threads">
            <BlockTitle title={data.title}/>
            <ThreadCards threads={threads} showActivity/>
        </div>
    );
}

export function AgentMoodBlock({data, ctx}) {
    const moods = ctx.moods;
    if (!moods || !moods.moods) return null;
    return (
        <div className="block-agent-mood">
            <BlockTitle title={data.title}/>
            <p className="block-agent-mood__window mono">Humeur des agents — {moodWindowLabel(moods)}</p>
            {moods.belowThreshold || !moods.results ? <BelowThresholdMessage moods={moods}/> : <MoodChart moods={moods}/>}
        </div>
    );
}

export function SignupCounterBlock({data, ctx}) {
    if (!(ctx.memberCount > 0)) return null;
    return (
        <div className="block-signup-counter block-key-figure">
            <strong><CountUp value={String(ctx.memberCount)} enabled/></strong>
            <span>{data.label || "agents inscrits"}</span>
        </div>
    );
}
